import { fillString } from '@local_modules/generic/string-template.js'
import { AutoAgGrid, generateString, setPageAsFullHeight } from '@local_modules/flokit'
import '@local_modules/flokit/styles.css'
import { setElementHtml } from '../../../../helpers/generic-js/dom.js'

import htmlTemplateIndex from './index.html'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'

const ALLOWED_OBJECT_NAMES = [
  'chartOfAccounts',
  'contacts',
  'journalLines',
  'journals',
  'sources'
]

/**
 *
 * @param {Object} params
 * @param {String} params.containerElementId
 * @param {Object} params.browserAppUser
 * @param {String} params.objectName
 *
 * @returns
 */
export async function showAdminDuplicatesForAllEntities (params) {
  console.log('showAdminDuplicatesForAllEntities')
  console.log('params', params)

  const { containerElementId, browserAppUser, objectName } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  if (!(objectName === null || ALLOWED_OBJECT_NAMES.includes(objectName))) {
    console.log('objectName not allowed', objectName)
    return
  }

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppUser })
  const elementId = 'i' + generateString()
  htmlIndex = fillString(htmlIndex, {
    elementId,
    objectName: objectName || 'all xero objects'
  })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  setPageAsFullHeight(true, { containerSelector: '#app-content' })

  // Set page title
  document.title = ['Entity duplicate journals'].join(' ')

  let apiUrl = '/api/data-review/xero_duplicates/:accountingOrganisationId/:objectName'
  apiUrl = fillString(apiUrl, {
    accountingOrganisationId: null,
    objectName
  })

  const autoAgGrid = new AutoAgGrid({
    containerSelector: '#entityGrid',
    sourceUrl: apiUrl,
    gridParams: {
      columns: {
        accounting_organisation_id: { show: false },
        organisation_name: {
          cellRenderer: function (cellParams) {
            return `<a href="/app/admin/entity/${cellParams.data.accounting_organisation_id}">${cellParams.data.organisation_name}</a>`
          }
        },
        chart_of_accounts_occurences: {
          cellRenderer: function (cellParams) {
            return `<a href="/app/admin/entity/${cellParams.data.accounting_organisation_id}/duplicates/chartOfAccounts">${cellParams.data.chart_of_accounts_occurences}</a>`
          }
        },
        contacts_occurences: {
          cellRenderer: function (cellParams) {
            return `<a href="/app/admin/entity/${cellParams.data.accounting_organisation_id}/duplicates/contacts">${cellParams.data.contacts_occurences}</a>`
          }
        },
        journal_lines_occurences: {
          cellRenderer: function (cellParams) {
            return `<a href="/app/admin/entity/${cellParams.data.accounting_organisation_id}/duplicates/journalLines">${cellParams.data.journal_lines_occurences}</a>`
          }
        },
        journals_occurences: {
          cellRenderer: function (cellParams) {
            return `<a href="/app/admin/entity/${cellParams.data.accounting_organisation_id}/duplicates/journals">${cellParams.data.journals_occurences}</a>`
          }
        },
        sources_occurences: {
          cellRenderer: function (cellParams) {
            return `<a href="/app/admin/entity/${cellParams.data.accounting_organisation_id}/duplicates/sources">${cellParams.data.sources_occurences}</a>`
          }
        }
      }
    }
  })
  console.log('autoAgGrid', autoAgGrid)
  return autoAgGrid
}
